import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "./UserPool";
import { AccessToken, RefreshToken } from "./AccessToken";

import { toast } from "react-toastify";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

import Box from "@mui/material/Box";
import "./LoginPage.scss";

import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import axios from "axios";
import OrgCodePopup from "./OrgCodePopup";
import IndexedDBManager from "./IndexedDBManager";
import { fetchOrgCodeAndValidate } from "./indexedDBHelper";
import LicenseExpiryPopup from "../../components/LicenseExpiryPopup";
import LicenseInfoPopup from "./LicenseInfoPopup";
import StoragePopUp from "./StoragePopUp";
import { usePermissions } from "./PermissionContext";

const Item = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // height: '60vh',
  overflow: "hidden",
  minHeight: "30vh",
}));

// const imgStyle = {
//   // width: '100%',
//   height: "60vh",
//   // maxHeight: '63vh',
//   // objectFit: 'cover',
//   borderRadius: "15px",
// };
const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    watch: watch1,
    setValue: setValue1,
  } = useForm();
  const {
    register: registerForgotPassword,
    handleSubmit: handleSubmitForgotPassword,
    formState: { errors: errorsForgotPassword },
    watch: watchForgotPassword,
    reset: resetForgotPassword,
  } = useForm();
  const history = useHistory();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [verifyCodeForm, setVerifyCodeForm] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showForgotNewPassword, setShowForgotNewPassword] = useState(false);
  const [showForgotConfirmPassword, setShowForgotConfirmPassword] =
    useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const [openWarning, setOpenWarning] = useState(false);
  const [expireInDays, setExpireInDays] = useState(null);
  const [openPopupInfo, setOpenPopupInfo] = useState(false);
  const [macAddress, setMacAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [openLimitModal, setOpenLimitModal] = useState(false);
  const [limitMessage, setLimitMessage] = useState("");
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);

  const handleOpen = () => setOpenPopupInfo(true); // Open the popup
  const handleClose = () => setOpenPopupInfo(false); // Close the popup
  const { refreshPermissions } = usePermissions();
  const getMacAddress = (code, mode) => {
    const apiUrl = `${process.env.REACT_APP_BACKEND_ROUTE_URL}organisation_license_info/`;
    const requestBody = {
      ORG_CODE: code,
      APP_MODE: mode,
    };

    axios
      .post(apiUrl, JSON.stringify(requestBody), {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        const mac = response.data?.data?.mac_address || "";
        setMacAddress(mac);
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "API Error:",
          error.response ? error.response.data : error.message
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    if (openPopupInfo) {
      setLoading(true);
      fetchOrgCodeAndValidate((data) => {
        if (data) {
          const { org_code, app_mode } = data;
          getMacAddress(org_code, app_mode);
        } else {
          console.error("Failed to fetch data from IndexedDB.");
          setLoading(false);
        }
      });
    }
  }, [openPopupInfo]);

  //

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    checkAndOpenPopup();
  }, []);

  // Prevent page scroll on small screens for login route only
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 600px)");
    const applyOverflow = () => {
      if (mediaQuery.matches) {
        document.documentElement.style.overflowY = "hidden";
        document.body.style.overflowY = "hidden";
      } else {
        document.documentElement.style.overflowY = "";
        document.body.style.overflowY = "";
      }
    };
    applyOverflow();
    mediaQuery.addEventListener("change", applyOverflow);
    return () => {
      mediaQuery.removeEventListener("change", applyOverflow);
      document.documentElement.style.overflowY = "";
      document.body.style.overflowY = "";
    };
  }, []);

  const checkAndOpenPopup = () => {
    const request = indexedDB.open("HLTHTEK-DB");

    request.onsuccess = (event) => {
      const db = event.target.result;

      if (!db) {
        console.error("Failed to open DB.");
        return;
      }

      console.log("in onsuccess", db.objectStoreNames.contains("T_ORG"));

      if (!db.objectStoreNames.contains("T_ORG")) {
        console.log(
          "T_ORG store doesn't exist. Upgrading database to create it..."
        );
        const currentVersion = db.version;
        db.close();

        const upgradeRequest = indexedDB.open("HLTHTEK-DB", currentVersion + 1);

        upgradeRequest.onupgradeneeded = function (event) {
          const upgradedDb = event.target.result;
          console.log("Upgrading DB and creating T_ORG store...");
          const store = upgradedDb.createObjectStore("T_ORG");
          store.put("", "ORG_CODE");
        };

        upgradeRequest.onsuccess = function (event) {
          console.log("T_ORG store created and data added successfully.");
          event.target.result.close();
          setPopupOpen(true);
        };

        upgradeRequest.onerror = function (event) {
          console.error("Error while upgrading DB:", event.target.error);
        };

        return;
      }

      db.close();

      // Reopen for transaction only
      const readRequest = indexedDB.open("HLTHTEK-DB");
      readRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction("T_ORG", "readwrite");
        const store = transaction.objectStore("T_ORG");
        const getRequest = store.get("ORG_CODE");

        getRequest.onsuccess = (event) => {
          const orgCodeValue = event.target.result;

          if (!orgCodeValue || orgCodeValue.trim() === "") {
            store.put("", "ORG_CODE");
            setPopupOpen(true);
          } else {
            fetchOrgCodeAndValidate((data) => {
              if (data) {
                validateLicence(data);
              } else {
                console.error("Failed to fetch data from IndexedDB.");
              }
            });
          }

          transaction.db.close();
        };

        getRequest.onerror = () => {
          console.error("Error fetching ORG_CODE.");
          transaction.db.close();
        };
      };
    };

    request.onerror = () => console.error("IndexedDB error.");

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      const store = db.createObjectStore("T_ORG");
      store.put("", "ORG_CODE");
      db.close(); // ✅ Close after initial upgrade
    };
  };

  const validateLicence = (data) => {
    const { org_code, app_mode } = data;

    if (!org_code || !app_mode) {
      console.error("Missing ORG_CODE or APP_MODE.");
      return;
    }

    const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}validate_license/`;
    const requestBody = { ORG_CODE: org_code, APP_MODE: app_mode };

    axios
      .post(apiUrl, requestBody, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        if (response.data.message !== "License Validated") {
          console.error("Verification failed:", response.data.message);
          toast.error(response.data.message);
          history.push("/License", {
            orgCode: org_code,
            appMode: app_mode,
            mac_address: response.data.data.mac_address,
          });
        } else {
          console.log("Success:", response.data);
          // toast.success(response.data.message);

          // const expireDays = response.data.data.license_expire_day_count;
          // setExpireInDays(expireDays);

          // setOpenWarning(true);

          const expireDaysRaw = response.data?.data?.license_expire_day_count;

          if (typeof expireDaysRaw === "number" && !isNaN(expireDaysRaw)) {
            setExpireInDays(expireDaysRaw);

            if (expireDaysRaw <= 30) {
              setOpenWarning(true);
            } else {
              console.log(
                `License is valid for ${expireDaysRaw} days, no popup shown.`
              );
            }
          } else {
            console.warn(
              "Invalid or missing 'license_expire_day_count' in response."
            );
          }
          const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}validate_assets_size/`;
          const requestBody = { ORG_CODE: org_code };
          axios
            .post(apiUrl, requestBody, {
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              if (
                response.data.status === "Failed"
                // &&
                // response.data.message ===
                //   "Data limit exceeded. Please contact administrator."
              ) {
                setLimitMessage(response.data.message);
                setOpenLimitModal(true);
              } else {
                console.log(response.data.message);
              }
            });
        }
      })
      .catch((error) => {
        console.error(
          "API Error:",
          error.response ? error.response.data : error.message
        );
        toast.error("API request failed.");
      });
  };

  // const onSubmit = async (data) => {
  //   setButtonDisabled(true);

  //   setTimeout(() => {
  //     setButtonDisabled(false);
  //   }, RESEND_OTP_TIMER);

  //   if (environment !== "PROD") {
  //     // Simulated non-production environment logic
  //     AccessToken(data.userName, data.password);
  //     setTimeout(() => {
  //       const role = sessionStorage.getItem("roleType");
  //     }, 3000);
  //   } else {
  //     // Production environment logic
  //     try {
  //       // const bodyFormData = {
  //       //   userName: data.userName,
  //       //   password: data.password,
  //       // };

  //       const bodyFormData = new FormData();
  //       bodyFormData.append("username", data.userName);
  //       bodyFormData.append("password", data.password);
  //       const response = await axios.post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}login/`,
  //         bodyFormData
  //       );

  //       const { message, role, email, name, facility_name } = response.data;
  //       sessionStorage.setItem("accessToken", response.data.access);
  //       sessionStorage.setItem("refreshToken", response.data.refresh);
  //       sessionStorage.setItem("accessTokenTime", new Date().getTime());
  //       sessionStorage.setItem(
  //         "subscriptionType",
  //         response.data.subscription_type
  //       );

  //       if (response.data.role === "partner admin") {
  //         sessionStorage.setItem("partner_id", response.data.partner_id);
  //       } else if (response.data.role === "partner user") {
  //         sessionStorage.setItem("partner_id", response.data.partner_id);
  //       } else if (response.data.role === "customer user") {
  //         sessionStorage.setItem("customer_name", response.data.customer_name);
  //         sessionStorage.setItem("partner_id", response.data.partner_id);
  //       } else if (response.data.role === "customer admin") {
  //         sessionStorage.setItem("customer_name", response.data.customer_name);
  //         sessionStorage.setItem("partner_id", response.data.partner_id);
  //       } else if (response.data.role === "facility admin") {
  //         sessionStorage.setItem("facility_name", response.data.facility_name);
  //       } else if (response.data.role === "facility user") {
  //         sessionStorage.setItem("facility_name", response.data.facility_name);
  //       } else if (response.data.role === "doctor") {
  //         sessionStorage.setItem("facility_name", response.data.facility_id);
  //       } else if (response.data.role === "pharmacy user") {
  //         sessionStorage.setItem("facility_name", response.data.facility_id);
  //       } else if (response.data.role === "lab user") {
  //         console.log("inside it ");
  //         sessionStorage.setItem("facility_name", response.data.facility_id);
  //       }

  //       if (response.data && response.data.access) {
  //         // Save user data to sessionStorage
  //         sessionStorage.setItem("userName", data.userName);
  //         sessionStorage.setItem("roleType", role);
  //         sessionStorage.setItem("email", email);
  //         sessionStorage.setItem("name", name);
  //         if (
  //           response.data.role !== "doctor" &&
  //           response.data.role !== "pharmacy user" &&
  //           response.data.role !== "lab user"
  //         ) {
  //           sessionStorage.setItem("facility_name", facility_name);
  //         }
  //         // if (role === "admin") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       console.log("Admin login successful");
  //         //       history.push("/hlthtek-admin-demo");
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "facility admin") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(async () => {
  //         //       const subscriptionType =
  //         //         sessionStorage.getItem("subscriptionType");

  //         //       if (
  //         //         subscriptionType ===
  //         //           "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //         //         subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //         //       ) {
  //         //         // Proceed to admin demo
  //         //         history.push("/hlthtek-admin-demo");
  //         //       } else {
  //         //         console.log("Test this time:", subscriptionType);
  //         //         const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

  //         //         // Show confirmation dialog
  //         //         const confirmed = await showConfirmDialog(message);
  //         //         if (confirmed) {
  //         //           history.push("/hlthtek-admin-demo");
  //         //         } else {
  //         //           // Clear session and redirect to home
  //         //           sessionStorage.clear();
  //         //           window.location.reload();
  //         //           history.push("/");
  //         //         }
  //         //       }
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "facility user" || role === "user") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(async () => {
  //         //       const subscriptionType =
  //         //         sessionStorage.getItem("subscriptionType");
  //         //       if (
  //         //         subscriptionType ===
  //         //           "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //         //         subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //         //       ) {
  //         //         // Proceed to hlthtek-demo
  //         //         history.push("/hlthtek-demo");
  //         //       } else {
  //         //         // Show confirmation dialog if subscription type doesn't match
  //         //         const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
  //         //         const confirmed = await showConfirmDialog(message);

  //         //         if (confirmed) {
  //         //           history.push("/hlthtek-demo");
  //         //         } else {
  //         //           // Clear session and redirect to home
  //         //           sessionStorage.clear();
  //         //           window.location.reload();
  //         //           history.push("/");
  //         //         }
  //         //       }
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "customer admin") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       history.push("/hlthtek-admin-demo");
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "partner admin") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       history.push("/hlthtek-admin-demo");
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "doctor") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       const subscriptionType =
  //         //         sessionStorage.getItem("subscriptionType");
  //         //       if (
  //         //         subscriptionType ===
  //         //           "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //         //         subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //         //       ) {
  //         //         history.push("/doctor/landing");
  //         //       } else {
  //         //         toast.error("Please login with HTMATE");
  //         //         sessionStorage.clear();
  //         //         window.location.reload();
  //         //       }
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else if (role === "lab user") {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       history.push("/hlthtek-demo");
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // } else {
  //         //   AccessToken(data.userName, data.password)
  //         //     .then(() => {
  //         //       history.push("/hlthtek-demo");
  //         //     })
  //         //     .catch((error) => {
  //         //       console.error("Login failed:", error);
  //         //       toast.error("Failed to login. Please check your credentials.");
  //         //     });
  //         // }

  //         if (role === "admin") {
  //           console.log("Admin login successful");
  //           history.push("/hlthtek-admin-demo");
  //         } else if (role === "facility admin") {
  //           const subscriptionType = sessionStorage.getItem("subscriptionType");

  //           if (
  //             subscriptionType ===
  //               "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //             subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //           ) {
  //             history.push("/hlthtek-admin-demo");
  //           } else {
  //             console.log("Test this time:", subscriptionType);
  //             const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

  //             showConfirmDialog(message).then((confirmed) => {
  //               if (confirmed) {
  //                 history.push("/hlthtek-admin-demo");
  //               } else {
  //                 sessionStorage.clear();
  //                 window.location.reload();
  //                 history.push("/");
  //               }
  //             });
  //           }
  //         } else if (role === "facility user" || role === "user") {
  //           const subscriptionType = sessionStorage.getItem("subscriptionType");

  //           if (
  //             subscriptionType ===
  //               "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //             subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //           ) {
  //             history.push("/hlthtek-demo");
  //           } else {
  //             const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

  //             showConfirmDialog(message).then((confirmed) => {
  //               if (confirmed) {
  //                 history.push("/hlthtek-demo");
  //               } else {
  //                 sessionStorage.clear();
  //                 window.location.reload();
  //                 history.push("/");
  //               }
  //             });
  //           }
  //         } else if (role === "customer admin") {
  //           history.push("/hlthtek-admin-demo");
  //         } else if (role === "partner admin") {
  //           history.push("/hlthtek-admin-demo");
  //         } else if (role === "doctor") {
  //           const subscriptionType = sessionStorage.getItem("subscriptionType");

  //           if (
  //             subscriptionType ===
  //               "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
  //             subscriptionType === "EHR/HMIS Service Without ABDM Connector"
  //           ) {
  //             history.push("/doctor/landing");
  //           } else {
  //             toast.error("Please login with HTMATE");
  //             sessionStorage.clear();
  //             window.location.reload();
  //           }
  //         } else if (role === "lab user") {
  //           history.push("/hlthtek-demo");
  //         } else {
  //           history.push("/hlthtek-demo");
  //         }
  //       } else {
  //         toast.error(response.data.detail);
  //       }
  //     } catch (error) {
  //       console.error("Authentication error:", error);
  //       if (error.response?.status === 401) {
  //         toast.error("Invalid username or password. Please try again.");
  //       } else {
  //         toast.error("An unexpected error occurred. Please try again later.");
  //       }
  //     }
  //   }
  // };
  const onSubmit = (data) => {
    setButtonDisabled(true);

    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);
    new Promise((resolve, reject) => {
      fetchOrgCodeAndValidate((result) => {
        if (result) {
          sessionStorage.setItem("APP_MODE", result.app_mode);
          sessionStorage.setItem("ORG_CODE", result.org_code);
          // sessionStorage.setItem(
          //   "USER_ACCESS_KEY",
          //   "23ddd049-8e7c-45d9-8b65-c7db68fd5051"
          // );
          resolve(result);
        } else {
          reject(new Error("Failed to fetch data from IndexedDB."));
        }
      });
    })
      .then(async () => {
        if (environment !== "PROD") {
          // Simulated non-production environment logic
          AccessToken(data.userName, data.password);
          setTimeout(() => {
            const role = sessionStorage.getItem("roleType");
          }, 3000);
        } else {
          // Production environment logic
          try {
            // const bodyFormData = {
            //   userName: data.userName,
            //   password: data.password,
            // };

            const bodyFormData = new FormData();
            bodyFormData.append("username", data.userName);
            bodyFormData.append("password", data.password);
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}login/`,
              bodyFormData
            );

            const {
              message,
              role,
              email,
              name,
              facility_name,
              role_permission,
            } = response.data;
            sessionStorage.setItem("accessToken", response.data.access);
            sessionStorage.setItem("salutation", response.data.salutation);
            sessionStorage.setItem("refreshToken", response.data.refresh);
            sessionStorage.setItem("accessTokenTime", new Date().getTime());
            sessionStorage.setItem(
              "subscriptionType",
              response.data.subscription_type
            );
            sessionStorage.setItem("USER_ACCESS_KEY", response.data.access_key);
            // if (response.data.role === "partner admin") {
            //   sessionStorage.setItem("partner_id", response.data.partner_id);
            // } else if (response.data.role === "partner user") {
            //   sessionStorage.setItem("partner_id", response.data.partner_id);
            // } else if (response.data.role === "customer user") {
            //   sessionStorage.setItem(
            //     "customer_name",
            //     response.data.customer_name
            //   );
            //   sessionStorage.setItem("partner_id", response.data.partner_id);
            // } else if (response.data.role === "customer admin") {
            //   sessionStorage.setItem(
            //     "customer_name",
            //     response.data.customer_name
            //   );
            //   sessionStorage.setItem("partner_id", response.data.partner_id);
            // } else if (response.data.role === "facility admin") {
            //   sessionStorage.setItem(
            //     "facility_name",
            //     response.data.facility_name
            //   );
            // } else if (response.data.role === "facility user") {
            //   sessionStorage.setItem(
            //     "facility_name",
            //     response.data.facility_name
            //   );
            // } else if (response.data.role === "doctor") {
            //   sessionStorage.setItem(
            //     "facility_name",
            //     response.data.facility_id
            //   );
            // } else if (response.data.role === "pharmacy user") {
            //   sessionStorage.setItem(
            //     "facility_name",
            //     response.data.facility_id
            //   );
            // } else if (response.data.role === "lab user") {
            //   console.log("inside it ");
            //   sessionStorage.setItem(
            //     "facility_name",
            //     response.data.facility_id
            //   );
            // }

            // if (response.data && response.data.access) {
            //   // Save user data to sessionStorage
            //   sessionStorage.setItem("userName", data.userName);
            //   sessionStorage.setItem("roleType", role);
            //   sessionStorage.setItem("email", email);
            //   sessionStorage.setItem("name", name);
            //   if (
            //     response.data.role !== "doctor" &&
            //     response.data.role !== "pharmacy user" &&
            //     response.data.role !== "lab user"
            //   ) {
            //     sessionStorage.setItem("facility_name", facility_name);
            //   }
            //   if (role === "admin") {
            //     console.log("Admin login successful");
            //     history.push("/hlthtek-admin-demo");
            //   } else if (role === "facility admin") {
            //     const subscriptionType =
            //       sessionStorage.getItem("subscriptionType");

            //     if (
            //       subscriptionType ===
            //         "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
            //       subscriptionType === "EHR/HMIS Service Without ABDM Connector"
            //     ) {
            //       history.push("/hlthtek-admin-demo");
            //     } else {
            //       console.log("Test this time:", subscriptionType);
            //       const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

            //       showConfirmDialog(message).then((confirmed) => {
            //         if (confirmed) {
            //           history.push("/hlthtek-admin-demo");
            //         } else {
            //           sessionStorage.clear();
            //           window.location.reload();
            //           history.push("/");
            //         }
            //       });
            //     }
            //   } else if (role === "facility user" || role === "user") {
            //     const subscriptionType =
            //       sessionStorage.getItem("subscriptionType");

            //     if (
            //       subscriptionType ===
            //         "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
            //       subscriptionType === "EHR/HMIS Service Without ABDM Connector"
            //     ) {
            //       history.push("/hlthtek-demo");
            //     } else {
            //       const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

            //       showConfirmDialog(message).then((confirmed) => {
            //         if (confirmed) {
            //           history.push("/hlthtek-demo");
            //         } else {
            //           sessionStorage.clear();
            //           window.location.reload();
            //           history.push("/");
            //         }
            //       });
            //     }
            //   } else if (role === "customer admin") {
            //     history.push("/hlthtek-admin-demo");
            //   } else if (role === "partner admin") {
            //     history.push("/hlthtek-admin-demo");
            //   } else if (role === "doctor") {
            //     const subscriptionType =
            //       sessionStorage.getItem("subscriptionType");

            //     if (
            //       subscriptionType ===
            //         "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
            //       subscriptionType === "EHR/HMIS Service Without ABDM Connector"
            //     ) {
            //       history.push("/doctor/landing");
            //     } else {
            //       toast.error("Please login with HTMATE");
            //       sessionStorage.clear();
            //       window.location.reload();
            //     }
            //   } else if (role === "lab user") {
            //     history.push("/hlthtek-demo");
            //   } else {
            //     history.push("/hlthtek-demo");
            //   }
            // } else {
            //   toast.error(response.data.detail);
            // }
            if (response.data && response.data.access) {
              sessionStorage.setItem("userName", data.userName);
              sessionStorage.setItem("roleType", role);
              // sessionStorage.setItem("roleType", role_permission[0].role);
              sessionStorage.setItem("email", email);
              sessionStorage.setItem("name", name);
              if (response.data.facility_name) {
                sessionStorage.setItem(
                  "facility_name",
                  response.data.facility_name
                );
              }
              await refreshPermissions();
              history.push("/main-landing");
            } else {
              toast.error(response.data.detail);
            }
          } catch (error) {
            console.error("Authentication error:", error);
            if (error.response?.status === 401) {
              toast.error("Invalid username or password. Please try again.");
            } else {
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          }
        }
      })
      .catch((error) => {
        console.error("License error:", error);
      });
  };

  const onSubmit1 = async (data) => {
    //ChangeCursor();
    var role = "";
    var email = "";
    var name = "";
    var facility_name = "";

    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });

    try {
      cognitoUser.authenticateUser(authDetails, {
        onSuccess: () => {
          cognitoUser.verifyAttribute("email", data.verifyCode, {
            onSuccess: () => {
              cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                  toast.error(err.message || JSON.stringify(err));
                  //ChangeCursor();
                  return;
                } else {
                  console.log(result);
                  sessionStorage.setItem("userName", user);
                  for (var i = 0; i < result.length; i++) {
                    if (result[i].getName() == "custom:role") {
                      role = result[i].getValue();
                      console.log("role", role);
                      sessionStorage.setItem("roleType", role);
                    }
                    if (result[i].getName() == "custom:name") {
                      name = result[i].getValue();
                      sessionStorage.setItem("name", name);
                      // console.log("testing..",name)
                    }
                    if (result[i].getName() == "custom:facility_name") {
                      facility_name = result[i].getValue();
                      sessionStorage.setItem("facility_name", facility_name);
                    }
                    if (result[i].getName() === "email") {
                      email = result[i].getValue();
                      sessionStorage.setItem("email", email);
                    }
                  }
                  if (role === "admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        console.log("Admin login successful");
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "facility admin") {
                    AccessToken(data.userName, data.password)
                      .then(async () => {
                        const subscriptionType =
                          sessionStorage.getItem("subscriptionType");

                        if (
                          subscriptionType ===
                            "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                          subscriptionType ===
                            "EHR/HMIS Service Without ABDM Connector"
                        ) {
                          // Proceed to admin demo
                          history.push("/hlthtek-admin-demo");
                        } else {
                          console.log("Test this time:", subscriptionType);
                          const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;

                          // Show confirmation dialog
                          const confirmed = await showConfirmDialog(message);
                          if (confirmed) {
                            history.push("/hlthtek-admin-demo");
                          } else {
                            // Clear session and redirect to home
                            sessionStorage.clear();
                            window.location.reload();
                            history.push("/");
                          }
                        }
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "facility user" || role === "user") {
                    AccessToken(data.userName, data.password)
                      .then(async () => {
                        const subscriptionType =
                          sessionStorage.getItem("subscriptionType");
                        if (
                          subscriptionType ===
                            "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                          subscriptionType ===
                            "EHR/HMIS Service Without ABDM Connector"
                        ) {
                          // Proceed to hlthtek-demo
                          history.push("/hlthtek-demo");
                        } else {
                          // Show confirmation dialog if subscription type doesn't match
                          const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
                          const confirmed = await showConfirmDialog(message);

                          if (confirmed) {
                            history.push("/hlthtek-demo");
                          } else {
                            // Clear session and redirect to home
                            sessionStorage.clear();
                            window.location.reload();
                            history.push("/");
                          }
                        }
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "customer admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "partner admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "doctor") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        const subscriptionType =
                          sessionStorage.getItem("subscriptionType");
                        if (
                          subscriptionType ===
                            "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                          subscriptionType ===
                            "EHR/HMIS Service Without ABDM Connector"
                        ) {
                          history.push("/doctor/landing");
                        } else {
                          toast.error("Please login with HTMATE");
                          sessionStorage.clear();
                          window.location.reload();
                        }
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "lab user") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  }
                }
              });
            },
            onFailure: (err) => {
              console.log(err.message);
              toast.error(err.message);
              //ChangeCursor();
            },
          });
        },
        onFailure: (err) => {
          console.log(err.message);
          toast.error(err.message);
          //ChangeCursor();
        },
      });
    } catch (error) {
      if (error === "Error: Network Error") {
        console.log("System is under maintenance.Please try again.");
        toast.error("System is under maintenance.Please try again.");
      } else {
        toast.error("Invalid user or password.");
        console.log("Invalid user or password.");
      }
      //ChangeCursor();
    }
  };

  const resendCode = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);
    //ChangeCursor();
    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: () => {
        cognitoUser.getAttributeVerificationCode("email", {
          onSuccess: (success) => {
            console.log(success);
            setVerifyCodeForm(true);
            //ChangeCursor();
          },
          onFailure: (err) => {
            console.log(err.message);
            toast.error(err);
            //ChangeCursor();
          },
        });
      },
      onFailure: (err) => {
        if (err.code === "UserNotConfirmedException") {
          console.log(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
          toast.error(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
        } else {
          console.log(err.message);
          toast.error(err.message);
        }
        //ChangeCursor();
      },
    });
  };

  // Combined forgot password submission
  const onSubmitForgotPassword = async (data) => {
    setForgotPasswordLoading(true);

    try {
      // Fetch org code and app mode from IndexedDB
      const orgData = await new Promise((resolve, reject) => {
        fetchOrgCodeAndValidate((result) => {
          if (result) {
            resolve(result);
          } else {
            reject(new Error("Failed to fetch data from IndexedDB."));
          }
        });
      });

      const requestBody = {
        email: data.email,
        new_password: data.newPassword,
        confirm_password: data.confirmPassword,
      };

      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}forgot_password/`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "Org-Code": orgData.org_code || "",
            "App-Mode": orgData.app_mode || "",
          },
        }
      );

      if (response.data.status === "Success") {
        toast.success(
          "Verification email sent! Please check your inbox to recover your password."
        );

        resetForgotPasswordFlow();
      } else {
        const msg = response.data?.message || "Failed to change password";
        if ( msg === "User not found") {
          toast.error("No user account found with this email address");
        } else {
          toast.error(msg);
        }
      }
    } catch (error) {
      console.error("Change password error:", error);
      if (error.response?.status === 400) {
        toast.error(
          error.response.data.message ||
            "Invalid request. Please check your inputs."
        );
      } else if (error.response?.status === 404) {
        toast.error("Email not found. Please check your email address.");
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  // Reset forgot password flow
  const resetForgotPasswordFlow = () => {
    setForgotPasswordMode(false);
    resetForgotPassword();
  };

  const toggleForgotPasswordMode = () => {
    setForgotPasswordMode(!forgotPasswordMode);
    if (forgotPasswordMode) {
      resetForgotPasswordFlow();
    }
  };

  return (
    <>
      <OrgCodePopup open={popupOpen} setOpen={setPopupOpen} />

      <main style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <div
          className="login-page"
          style={{
            color: "#1d364d",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: "100%",
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: { xs: 1, sm: 2, md: 4 },
              backgroundImage: "url('/newImages/login_background.svg')",

              backgroundSize: "cover", // ensures full coverage
              backgroundPosition: "center",
              height: { xs: "100%", sm: "100%", md: "100vh" },
              boxSizing: "border-box",
            }}
          >
            <Grid
              container
              sx={{
                width: { xs: "95%", sm: "90%", md: "867px" },
                boxShadow: 3,
                borderRadius: "20px",
                overflow: { xs: "auto", md: "hidden" },
                height: { md: "430px" },
                maxHeight: { xs: "100%", sm: "100%" },
              }}
            >
              {/* LEFT PANEL */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  backgroundColor: "#1d364d",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: { xs: 3, md: 4 },
                  minHeight: { xs: "240px", md: "auto" },
                }}
              >
                <h2 style={{ marginBottom: "15px", color: "#fff" }}>Login</h2>
                <h6 style={{ marginBottom: "20px", color: "#fff" }}>
                  Your Digital Healthcare Partner
                </h6>
                <Box
                  component="img"
                  src={"/newImages/loginImageGroup.svg"}
                  alt="HT Mate Icon"
                  sx={{
                    borderRadius: "5px",
                    width: { xs: 140, sm: 180, md: 200 },
                    height: { xs: 140, sm: 180, md: 200 },
                  }}
                />
              </Grid>

              {/* RIGHT PANEL */}
              <Grid
                item
                xs={12}
                md={8}
                sx={{
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: { xs: 3, md: 4 },
                }}
              >
                {!verifyCodeForm ? (
                  <div style={{ width: "100%", maxWidth: "510px" }}>
                    {!forgotPasswordMode ? (
                      <>
                        <form
                          className="contact-list list-unstyled"
                          name="login"
                          id="login"
                          noValidate
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div style={{ marginBottom: "10px" }}>
                            <input
                              name="userName"
                              type="text"
                              className="form-control"
                              required={true}
                              placeholder="Username"
                              autoComplete="section-login username"
                              {...register("userName", {
                                required: "userName is required.",
                              })}
                            />
                            {errors.userName && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "left",
                                }}
                              >
                                {errors.userName.message}
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              marginBottom: "10px",
                              position: "relative",
                            }}
                          >
                            <input
                              name="password"
                              className="form-control"
                              type={showLoginPassword ? "text" : "password"}
                              required={true}
                              placeholder="Password"
                              autoComplete="section-login current-password"
                              {...register("password", {
                                required: "Password is required.",
                              })}
                            />
                            <span
                              className="password-toggle"
                              onMouseDown={() => setShowLoginPassword(true)}
                              onMouseUp={() => setShowLoginPassword(false)}
                              onMouseLeave={() => setShowLoginPassword(false)}
                              onTouchStart={() => setShowLoginPassword(true)}
                              onTouchEnd={() => setShowLoginPassword(false)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              {showLoginPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                            {errors.password && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "left",
                                }}
                              >
                                {errors.password.message}
                              </div>
                            )}
                          </div>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <button
                              className="btn btn__secondary mt-10"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                        <div
                          style={{
                            marginTop: "15px",
                            textAlign: "center",
                          }}
                        >
                          <span
                            onClick={toggleForgotPasswordMode}
                            style={{
                              color: "#0E3F66",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontSize: "14px",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.color = "#000")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.color = "#0E3F66")
                            }
                          >
                            Forgot Password?
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Combined Forgot Password Form */}
                        <form
                          className="contact-list list-unstyled"
                          name="forgotPassword"
                          id="forgotPassword"
                          noValidate
                          autoComplete="off"
                          onSubmit={handleSubmitForgotPassword(
                            onSubmitForgotPassword
                          )}
                        >
                          {/* Honeypot fields to absorb aggressive browser/password-manager autofill */}
                          <input
                            type="text"
                            name="username"
                            autoComplete="username"
                            tabIndex={-1}
                            aria-hidden="true"
                            style={{ position: "absolute", left: "-9999px", height: 0, opacity: 0, pointerEvents: "none" }}
                          />
                          <input
                            type="password"
                            name="password"
                            autoComplete="current-password"
                            tabIndex={-1}
                            aria-hidden="true"
                            style={{ position: "absolute", left: "-9999px", height: 0, opacity: 0, pointerEvents: "none" }}
                          />
                          <div style={{ marginBottom: "10px" }}>
                            <input
                              name="email"
                              type="email"
                              className="form-control"
                              required={true}
                              placeholder="Email Address"
                              autoComplete="off"
                              data-lpignore="true"
                              data-1p-ignore="true"
                              data-bwignore="true"
                              autoCapitalize="none"
                              spellCheck={false}
                              {...registerForgotPassword("email", {
                                required: "Email is required.",
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.(?:com|net|org|edu|gov|mil|io|co|in|[A-Z]{2})$/i,
                                  message: "Invalid email address",
                                },
                              })}
                            />
                            {errorsForgotPassword.email && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "left",
                                }}
                              >
                                {errorsForgotPassword.email.message}
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              marginBottom: "10px",
                              position: "relative",
                            }}
                          >
                            <input
                              name="newPassword"
                              className="form-control"
                              type={showForgotNewPassword ? "text" : "password"}
                              required={true}
                              placeholder="New Password"
                              autoComplete="new-password"
                             
                              {...registerForgotPassword("newPassword", {
                                required: "New password is required.",
                                pattern: {
                                  value:
                                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/,
                                  message:
                                    "Password must include an alphabet, a number, a special character, and be at least 8 characters",
                                },
                              })}
                            />
                            <span
                              className="password-toggle"
                              onMouseDown={() => setShowForgotNewPassword(true)}
                              onMouseUp={() => setShowForgotNewPassword(false)}
                              onMouseLeave={() =>
                                setShowForgotNewPassword(false)
                              }
                              onTouchStart={() =>
                                setShowForgotNewPassword(true)
                              }
                              onTouchEnd={() => setShowForgotNewPassword(false)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              {showForgotNewPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                            {errorsForgotPassword.newPassword && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "left",
                                }}
                              >
                                {errorsForgotPassword.newPassword.message}
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              marginBottom: "10px",
                              position: "relative",
                            }}
                          >
                            <input
                              name="confirmPassword"
                              className="form-control"
                              type={
                                showForgotConfirmPassword ? "text" : "password"
                              }
                              required={true}
                              placeholder="Confirm New Password"
                              autoComplete="new-password"
                              
                              {...registerForgotPassword("confirmPassword", {
                                required: "Confirm password is required.",
                                pattern: {
                                  value:
                                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/,
                                  message:
                                    "Password must include an alphabet, a number, a special character, and be at least 8 characters",
                                },
                                validate: (value) =>
                                  value ===
                                    watchForgotPassword("newPassword") ||
                                  "Passwords do not match",
                              })}
                            />
                            <span
                              className="password-toggle"
                              onMouseDown={() =>
                                setShowForgotConfirmPassword(true)
                              }
                              onMouseUp={() =>
                                setShowForgotConfirmPassword(false)
                              }
                              onMouseLeave={() =>
                                setShowForgotConfirmPassword(false)
                              }
                              onTouchStart={() =>
                                setShowForgotConfirmPassword(true)
                              }
                              onTouchEnd={() =>
                                setShowForgotConfirmPassword(false)
                              }
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              {showForgotConfirmPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                            {errorsForgotPassword.confirmPassword && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "left",
                                }}
                              >
                                {errorsForgotPassword.confirmPassword.message}
                              </div>
                            )}
                          </div>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <button
                              className="btn btn__secondary"
                              type="submit"
                              disabled={forgotPasswordLoading}
                            >
                              {forgotPasswordLoading
                                ? "Changing Password..."
                                : "Change Password"}
                            </button>
                          </div>
                        </form>
                        <div
                          style={{
                            marginTop: "10px",
                            textAlign: "center",
                          }}
                        >
                          <span
                            onClick={toggleForgotPasswordMode}
                            style={{
                              color: "#0E3F66",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontSize: "14px",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.color = "#000")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.color = "#0E3F66")
                            }
                          >
                            Back to Login
                          </span>
                        </div>
                      </>
                    )}
                    <div
                      style={{
                        marginTop: "10px",
                        color: "#555",
                        fontSize: "14px",
                        textAlign: "center",
                        maxWidth: "550px", // widen so text breaks into 2 lines
                        marginLeft: "auto",
                        marginRight: "auto",
                        lineHeight: "1.6",
                      }}
                    >
                      <div>
                        {forgotPasswordMode
                          ? "Enter your email address and new password to reset your account access."
                          : "Login to access your secure and personalized health platform. Experience the future of healthcare with Hlthtek.com's powerful EHR system aka HTMate!"}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <span
                        onClick={handleOpen}
                        style={{
                          color: "#0E3F66",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#000")} // Darker on hover
                        onMouseLeave={(e) => (e.target.style.color = "#0E3F66")}
                      >
                        License Information
                      </span>
                    </div>
                  </div>
                ) : (
                  /* keep your verify code UI unchanged */
                  <div className="footer-widget-contact additional-footer-styles ">
                    {/* ... your verify code form here ... */}
                  </div>
                )}
              </Grid>
            </Grid>
          </Box>
        </div>
      </main>

      <LicenseExpiryPopup
        open={openWarning}
        setOpen={setOpenWarning}
        expireInDays={expireInDays}
      />
      {/* <button onClick={handleOpen}>Open License Info</button> */}
      <LicenseInfoPopup
        open={openPopupInfo}
        setOpen={setOpenPopupInfo}
        macAddress={macAddress}
        loading={loading}
      />
      <StoragePopUp
        open={openLimitModal}
        setOpen={setOpenLimitModal}
        message={limitMessage}
      />
    </>
  );
}

export default Login;
